import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { APP_URL_PAYMENT, STORAGE_KEY_DATA_FOR_RETRY_PAYMENT, STORAGE_KEY_URL_BEFORE_PAYMENT } from '../../../const';
import StorageService from '../../../service/StorageService';
import { getPurchasesBannerData } from '../../../store/slices/catalogSlice';
import { togglePaymentIssueNotification } from '../../../store/slices/chatsSlice';
import { toggleUserMenu } from '../../../store/slices/globalSlice';
import { setShowPaymentModal } from '../../../store/slices/modalsSlice';
import { getPaymentsState, getSubscriptionPlan, getTrialPlan, setCurrentPaymentData } from '../../../store/slices/paymentsSlice';
import { gaEvents } from '../../../utils/analytics';
import Spinner from '../Spinner';
import styles from './styles.module.scss';

export const paymentBtnType = {
    trial: 'trial',
    subscription: 'subscription',
    product: 'product'
};

const PaymentButton = ({ text = '', disable = false, type = 'product', extraClasses = [], abTesting = false, googleEvent = '' }) => {
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { title } = useSelector(getPurchasesBannerData);
    const { loading, productsList } = useSelector(getPaymentsState);
    const trial = useSelector(getTrialPlan);
    const premium = useSelector(getSubscriptionPlan);
    const product = productsList[0];

    let paymentData = { paymentType: type };
    switch (type) {
        case 'product':
            paymentData = {
                ...paymentData,
                paymentId: product?.id,
                paymentPrice: product?.price
            };
            break;
        case 'subscription':
            paymentData = {
                ...paymentData,
                paymentId: premium?.id,
                paymentPrice: premium?.price
            };
            break;
        case 'trial':
            paymentData = {
                ...paymentData,
                paymentId: trial?.id,
                paymentPrice: trial?.price
            };
            break;
    }

    const onPaymentBtn = () => {
        if (abTesting && type === 'trial') {
            gaEvents.onTrialBannerClick(title);
        }

        switch (googleEvent) {
            case 'chatPopup':
                gaEvents.onPaymentPopupBtn(type);
                break;
            case 'profile':
                gaEvents.onPaymentProfileBtn(type);
                break;
            case 'issue':
                gaEvents.onIssueBtn();
                break;
        }

        dispatch(setCurrentPaymentData(paymentData));
        dispatch(togglePaymentIssueNotification(false));
        dispatch(setShowPaymentModal(false));
        dispatch(toggleUserMenu(false));
        StorageService.add(STORAGE_KEY_URL_BEFORE_PAYMENT, pathname);
        StorageService.add(STORAGE_KEY_DATA_FOR_RETRY_PAYMENT, paymentData);
        navigate(`/${APP_URL_PAYMENT}`);
    };

    return (
        <button onClick={onPaymentBtn} className={classNames(styles.btn, ...extraClasses, { [styles.disabled]: loading || disable })}>
            {loading ? <Spinner width={24} height={24} /> : !!text && text}
        </button>
    );
};

export default PaymentButton;
